import React from "react";
import { Modal, Form, Checkbox, Button } from "antd";

const ViewConfigurationModal = ({
  visible,
  onCancel,
  onFinish,
  initialValues,
}) => {
  const [form] = Form.useForm();

  return (
    <Modal
      title="Configurar esta vista"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="back" onClick={onCancel}>
          Cancelar
        </Button>,
        <Button key="submit" type="primary" onClick={() => form.submit()}>
          Guardar
        </Button>,
      ]}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={initialValues}
      >
        <Form.Item name="hidden" valuePropName="checked">
          <Checkbox>Ocultar campos vacíos</Checkbox>
        </Form.Item>
        <Form.Item name="timelineVisible" valuePropName="checked">
          <Checkbox>Mostrar línea de tiempo</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ViewConfigurationModal;
